import { render, staticRenderFns } from "./Urllist.vue?vue&type=template&id=3b84c942&scoped=true"
import script from "./Urllist.vue?vue&type=script&lang=js"
export * from "./Urllist.vue?vue&type=script&lang=js"
import style0 from "./Urllist.vue?vue&type=style&index=0&id=3b84c942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84c942",
  null
  
)

export default component.exports